import React, { useEffect, useState } from 'react';
import { Badge, Button, Form, Modal, Spinner } from 'react-bootstrap';
import { inventoryAPI } from '../../services';
import { toast } from 'react-toastify';

const MaterialPackageFormModal = ({ show, pkg, materialId, materialUnit, onHide, onSuccess }) => {
  const isEdit = !!pkg;
  const isBaseUnit = pkg?.is_base_unit === true;

  const [form, setForm] = useState({
    name: '',
    unit_label: '',
    quantity_in_base: '',
    is_default: false,
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show) {
      if (isEdit) {
        setForm({
          name: pkg.name || '',
          unit_label: pkg.unit_label || '',
          quantity_in_base: String(pkg.quantity_in_base || ''),
          is_default: pkg.is_default || false,
        });
      } else {
        setForm({ name: '', unit_label: '', quantity_in_base: '', is_default: false });
      }
    }
  }, [show, pkg, isEdit]);

  const handleChange = (field, value) =>
    setForm((prev) => ({ ...prev, [field]: value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) { toast.error('Tên đơn vị không được để trống'); return; }
    const qty = parseFloat(form.quantity_in_base);
    if (!qty || qty <= 0) { toast.error('Số lượng quy đổi phải > 0'); return; }

    setLoading(true);
    try {
      const data = {
        name: form.name.trim(),
        unit_label: form.unit_label.trim() || undefined,
        quantity_in_base: qty,
        is_default: form.is_default,
      };
      if (isEdit) {
        await inventoryAPI.updateMaterialPackage(pkg.id, data);
        toast.success('Cập nhật đơn vị nhập hàng thành công');
      } else {
        await inventoryAPI.createMaterialPackage({ ...data, material_id: materialId });
        toast.success('Tạo đơn vị nhập hàng thành công');
      }
      onSuccess?.();
      onHide();
    } catch (err) {
      toast.error(err?.message || 'Lưu thất bại');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>
            {isEdit ? 'Sửa đơn vị nhập hàng' : 'Thêm đơn vị nhập hàng'}
            {isBaseUnit && (
              <Badge bg="secondary" className="ms-2 fs-6">Đơn vị cơ sở</Badge>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isBaseUnit && (
            <div className="alert alert-info py-2 small mb-3">
              Đây là đơn vị cơ sở của NVL này. Tên và nhãn có thể chỉnh sửa, nhưng số lượng quy đổi luôn là 1.
            </div>
          )}

          <Form.Group className="mb-3">
            <Form.Label>Tên đầy đủ *</Form.Label>
            <Form.Control
              value={form.name}
              onChange={(e) => handleChange('name', e.target.value)}
              placeholder="VD: Bao 25kg, Chai 1L, Thùng 12 chai..."
              autoFocus
              disabled={isBaseUnit}
            />
            <Form.Text className="text-muted">
              Tên mô tả đầy đủ của đơn vị đóng gói.
            </Form.Text>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Nhãn ngắn (hiển thị)</Form.Label>
            <Form.Control
              value={form.unit_label}
              onChange={(e) => handleChange('unit_label', e.target.value)}
              placeholder="VD: bao, chai, thùng, kg, g..."
              maxLength={20}
            />
            <Form.Text className="text-muted">
              Nhãn ngắn dùng trong form nhập hàng (VD: "bao", "chai"). Nếu để trống sẽ dùng tên đầy đủ.
            </Form.Text>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>
              Số lượng quy đổi về {materialUnit || 'đơn vị cơ sở'} *
            </Form.Label>
            <Form.Control
              type="number"
              min="0.001"
              step="any"
              value={form.quantity_in_base}
              onChange={(e) => handleChange('quantity_in_base', e.target.value)}
              placeholder={`VD: 25000 (bao 25kg, đơn vị cơ sở là ${materialUnit || 'G'})`}
              disabled={isBaseUnit}
            />
            <Form.Text className="text-muted">
              1 đơn vị này = bao nhiêu {materialUnit || 'đơn vị cơ sở'}?
            </Form.Text>
          </Form.Group>

          <Form.Check
            type="checkbox"
            label="Đặt làm đơn vị nhập mặc định"
            checked={form.is_default}
            onChange={(e) => handleChange('is_default', e.target.checked)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide} disabled={loading}>Hủy</Button>
          <Button type="submit" variant="primary" disabled={loading}>
            {loading ? <Spinner size="sm" /> : (isEdit ? 'Lưu thay đổi' : 'Tạo đơn vị')}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default MaterialPackageFormModal;
